import { Link } from "react-router-dom";
import { Mail, MapPin, Globe, Phone } from "lucide-react";
import { WHATSAPP_DISPLAY, whatsappLink } from "@/data/catalog";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1A4331] text-[#F9F6F0]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="inline-block bg-[#F9F6F0] rounded-xl px-4 py-3 mb-4">
            <img src="/logo.png" alt="11 Star — Wellness for Life" className="h-10 w-auto" />
          </div>
          <p className="text-sm text-[#F9F6F0]/70 leading-relaxed max-w-xs">
            100% herbal Ayurvedic supplements, manufactured at a certified facility in Jaipur and
            shipped all over India.
          </p>
        </div>

        <div>
          <h3 className="font-display text-lg font-semibold mb-4">Shop</h3>
          <ul className="space-y-2 text-sm">
            {[
              ["All Products", "/products"],
              ["Piles Care", "/products/piles-care"],
              ["Absolute Power", "/products/absolute-power"],
              ["Ortho Capsule", "/products/ortho"],
              ["Diabetes Capsule", "/products/diabetes"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-shop-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[#F9F6F0]/70 hover:text-[#D4AF37] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-lg font-semibold mb-4">Company</h3>
          <ul className="space-y-2 text-sm">
            {[
              ["Why Eleven Stars", "/why-us"],
              ["Super Herbs", "/herbs"],
              ["Certifications", "/certifications"],
              ["Customer Reviews", "/reviews"],
              ["Contact Us", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[#F9F6F0]/70 hover:text-[#D4AF37] transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div id="contact">
          <h3 className="font-display text-lg font-semibold mb-4">Contact</h3>
          <ul className="space-y-3 text-sm text-[#F9F6F0]/70">
            <li className="flex gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#D4AF37]" />
              <span>F-13, First Floor, Royal Plaza, Central Spine, Vidyadhar Nagar, Jaipur, Rajasthan — 302039</span>
            </li>
            <li className="flex gap-2 items-center">
              <Phone className="w-4 h-4 shrink-0 text-[#D4AF37]" />
              <a href={whatsappLink("Namaste! I have a question about Eleven Stars products.")} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="hover:text-[#D4AF37] transition-colors">
                {WHATSAPP_DISPLAY} (WhatsApp)
              </a>
            </li>
            <li className="flex gap-2 items-center">
              <Mail className="w-4 h-4 shrink-0 text-[#D4AF37]" />
              <a href="mailto:support@11starwellness.com" data-testid="footer-email" className="hover:text-[#D4AF37] transition-colors">
                support@11starwellness.com
              </a>
            </li>
            <li className="flex gap-2 items-center">
              <Globe className="w-4 h-4 shrink-0 text-[#D4AF37]" />
              <a href="https://www.11starwellness.com" target="_blank" rel="noreferrer" data-testid="footer-website" className="hover:text-[#D4AF37] transition-colors">
                www.11starwellness.com
              </a>
            </li>
          </ul>
          <div className="flex flex-wrap gap-2 mt-5">
            {["ISO 9001:2015", "WHO-GMP", "ISO 22000:2018", "FSSAI"].map((b) => (
              <span key={b} className="text-[10px] uppercase tracking-wider border border-[#D4AF37]/40 text-[#D4AF37] rounded-full px-3 py-1">
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#F9F6F0]/50">
        <span>© {new Date().getFullYear()} Eleven Stars. All rights reserved.</span>
        <span>
          Ayurvedic supplements. Not intended to diagnose, treat, cure or prevent any disease.
          Consult your healthcare professional.
        </span>
      </div>
    </div>
  </footer>
);
